import { showConfirm, showError } from '../../components/Messages';
import { buildQueryString } from '../../utils/Functions';
import { BaseController } from './../BaseController';

export default class PerfilDeUsuarioController extends BaseController {
   constructor(props) {
      super(props);
      this.name = 'PerfilDeUsuarioController';
   }

   getTitulosDaTabela = () => {
      return [
         { titulo: this.lang.codigo, orderby: 'Id', className: 'codigo' },
         { titulo: this.lang.telaDeCadastroDePerfilDeUsuario.nome, width: '50%', orderby: 'Nome' },
         { titulo: this.lang.telaDeCadastroDePerfilDeUsuario.situacao, width: '25%', orderby: null },
         { titulo: this.lang.telaDeCadastroDePerfilDeUsuario.tipoDePerfil, width: '25%', orderby: null },
      ];
   };

   getDadosDaTabela = (item) => {
      return [
         item.id,
         item.nome,
         item.situacao ? item.situacao.descricao : null,
         item.tipoDePerfil ? item.tipoDePerfil.descricao : null,
      ];
   };

   getObjetoDeDados = () => {
      return new Promise((resolve, reject) => {
         let state = this.view.state;
         let item = state.itemSelecionado;

         if (!item.nome) {
            showError(this.lang.telaDeCadastroDePerfilDeUsuario.mensagens.informeONomeDoPerfilDeUsuario);
            reject();
            return;
         }

         if (!item.acessos || (item.acessos && item.acessos.length === 0)) {
            showError(this.lang.telaDeCadastroDePerfilDeUsuario.mensagens.informePeloMenosUmAcesso);
            reject();
            return;
         }

         var input = {
            nome: item.nome,
            situacao: item.situacao ? item.situacao.id : 0,
            acessos: item.acessos,
            tipoDePerfil: item.tipoDePerfil ? item.tipoDePerfil.id : 0,
         };

         if (state.alterando) {
            input.id = parseInt(item.id);
         }

         if (state.alterando && item.situacao && item.situacao.id === 2 && item.emUso) {
            showConfirm(
               this.lang.telaDeCadastroDePerfilDeUsuario.mensagens.existemUsuariosVinculadosAoPerfilDesejaProsseguir,
               () => {
                  resolve(input);
               },
               () => {
                  reject();
                  return;
               },
               this.lang.sim,
               this.lang.nao
            );
         } else {
            resolve(input);
         }
      });
   };

   inserirTodas = () => {
      return new Promise((resolve, reject) => {
         let state = this.view.state;
         this.api
            .get(
               '/rotinadosistema' +
                  buildQueryString(null, null, 'id', {
                     Searchable: '',
                     DisponivelParaNeos: state.itemSelecionado.tipoDePerfil
                        ? state.itemSelecionado.tipoDePerfil.id === 1
                        : false,
                     DisponivelParaEmpresa: state.itemSelecionado.tipoDePerfil
                        ? state.itemSelecionado.tipoDePerfil.id === 2
                        : false,
                     DisponivelParaCliente: state.itemSelecionado.tipoDePerfil
                        ? state.itemSelecionado.tipoDePerfil.id === 3
                        : false,
                  })
            )
            .then((result) => {
               state.itemSelecionado.acessos = [];

               result.items.forEach((rotina) => {
                  state.itemSelecionado.acessos.push({ rotina: rotina });
               });

               this.view.setState({ itemSelecionado: state.itemSelecionado }, () => {
                  this.view.setState({ mostrarAcessos: false }, () => this.view.setState({ mostrarAcessos: true }));
               });

               resolve();
            });
      });
   };
}
